import { captureEvent } from '../../utils/posthogClient';
import { PH_CTA, PH_DIRECT, PH_PLACEMENT } from '../../utils/posthogEvents';
import parser from 'html-react-parser';
import Image from 'next/image';
import Link from 'next/link';
import { useState } from 'react';
import { useDocContext } from '../../context/DocContext';
import { Container, Row, Col } from 'react-bootstrap';
import { ArrowRightShort, BlueCheckMark } from '../../assets/icons';
import { ArrowRightLong } from '../../assets/icons';
import {
  trustPilotNewer,
  stdStep1,
  stdStep2,
  stdStep3,
  medicineBottle,
} from '../../assets/images';
import Ribbon from '../ribbon';

const HeroMedications = ({
  breadcrumbs = null,
  category,
  title,
  path,
  subText,
  avatar,
  hero,
  showNav,
  service,
  price,
  sections,
  symptoms,
  content,
}) => {
  const used_to_treat = content?.used_to_treat;
  const heading = content?.heading.split(' ');
  const [activeSection, setActiveSection] = useState(0);

  return (
    <>
      <section className='tw-w-full tw-pb-8 lg:tw-py-32 tw-bg-[#Fff]'>
        <div className='tw-mx-auto tw-w-[92%] lg:tw-w-[83%] 2xl:tw-w-[90rem]'>
          <Container fluid className='px-0'>
            <Row className=' tw-flex tw-flex-col-reverse md:tw-flex-row'>
              <Col xs={12} lg={6}>
                <div className='tw-w-full tw-flex tw-flex-col tw-gap-y-6'>
                  {breadcrumbs}
                  <div>
                    {' '}
                    <h1 className='tw-m-0 tw-font-semibold tw-text-4xl lg:tw-text-[2.5rem] xl:tw-text-5xl tw-leading-[3rem] xl:tw-leading-relaxed'>
                      {heading[0]}{' '}
                      <span className='gradientText'>
                        {heading.slice(1).join(' ')}
                      </span>
                    </h1>
                    <p className=' tw-text-doc_gray  tw-mb-0'>
                      Prescription Reviewed & Sent Fast
                    </p>
                  </div>

                  <p className='tw-m-0 tw-mb-0 tw-text-[#5F5F5F] lg:tw-w-3/4'>
                    {used_to_treat}
                  </p>

                  <ul className='tw-p-0 tw-list-none tw-flex tw-flex-col tw-gap-y-4 lg:tw-gap-y-6'>
                    <li className='tw-flex tw-items-center tw-gap-x-3 tw-text-doc_blue tw-text-sm md:text-base xl:tw-text-xl'>
                      <BlueCheckMark />
                      Reviewed by a licensed U.S. provider
                    </li>
                    <li className='tw-flex tw-items-center tw-gap-x-3 tw-text-doc_blue tw-text-sm md:text-base xl:tw-text-xl'>
                      <BlueCheckMark />
                      Prescription sent to your local pharmacy
                    </li>
                    <li className='tw-flex tw-items-center tw-gap-x-3 tw-text-doc_blue tw-text-sm md:text-base xl:tw-text-xl'>
                      <BlueCheckMark />
                      No insurance required
                    </li>
                  </ul>
                </div>
                <div className='tw-flex tw-flex-col tw-gap-y-4 tw-w-full tw-mt-6'>
                  <div className='tw-flex tw-flex-col tw-gap-y-2 XL:tw-flex-row lg:tw-items-center tw-gap-x-4 tw-w-full'>
                    <button
                      //onClick={() => getTreated('EPzuICJy88')}
                      className='refill-cta tw-border-none tw-w-full lg:tw-w-max '
                    >
                      <Link href={`${path}`}>
                        <div
                          onClick={() =>
                            captureEvent(PH_DIRECT.CLICK, {
                              cta: PH_CTA.START_TREATMENT,
                              placement: PH_PLACEMENT.MEDICATION_PAGE,
                            })
                          }
                          className='tw-w-full tw-bg-black tw-text-white tw-flex tw-items-center tw-gap-x-2 tw-justify-center lg:tw-w-[403px] tw-h-14 lg:tw-h-[56px] tw-rounded-full tw-font-medium lg:tw-text-xl'
                        >
                           Begin Medical Assessment 
                          <ArrowRightShort />
                        </div>
                      </Link>
                    </button>

                    <div className='tw-flex tw-items-center tw-justify-center tw-gap-x-1  '>
                      <p className='tw-text-sm tw-m-0'>at just</p>
                      <p className='tw-m-0 tw-font-semibold gradientText'>
                        ${price || '39.99'}
                      </p>
                    </div>
                  </div>

                  <p className='tw-m-0 tw-text-center lg:tw-text-left tw-text-[#5F5F5F] tw-text-sm'>
                    5-minute assessment • No office visit required
                  </p>
                </div>
              </Col>
              <Col
                xs={12}
                lg={6}
                className='tw-relative tw-mt-0 lg:tw-mt-0 tw-flex tw-justify-center'
              >
                <div className='position-relative tw-h-[343px] lg:tw-min-h-[550px] tw-w-3/4'>
                  <Image
                    src={hero}
                    alt='hero-image'
                    layout='fill'
                    className='tw-rounded-2xl tw-object-cover'
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </section>{' '}
      <Ribbon />
      {/* New Section for the disease */}
      {showNav ? (
        <div className={`theNavBar`}>
          <div className='theInnerNavBar'>
            {sections.map((item, index) => (
              <a
                key={index}
                href={`#${index + 2}`}
                onClick={() => setActiveSection(index)}
              >
                <span
                  className={`${
                    index === activeSection ? 'activeSection' : 'section'
                  }`}
                >
                  {index + 1}.&nbsp; {item.title}
                </span>
              </a>
            ))}
          </div>
        </div>
      ) : (
        <br />
      )}
    </>
  );
};

export default HeroMedications;
